'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('zoomInstall', {
                parent: '',
                url: '/zoominstall',
                data: {
                    roles: [],
                    pageTitle: 'zoomInstall.title',
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/zoom/templates/zoomInstall.html',
                        controller: 'ZoomInstallController',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('zoomInstall');
                        return $translate.refresh();
                    }]
                }
            })
            .state('installedZoom', {
                parent: 'site',
                url: '/installedZoom',
                data: {
                    roles: [],
                    pageTitle: 'installedZoom.title',
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/zoom/templates/installedZoom.html',
                        controller: 'InstalledZoomController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('installedZoom');
                        return $translate.refresh();
                    }]
                }
            })
            .state('unauthorizedUserZoom', {
                parent: 'site',
                url: '/unauthorizedUserZoom',
                data: {
                    roles: [],
                    pageTitle: 'unauthorizedUserZoom.title',
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/zoom/templates/unauthorizedUserZoom.html',
                        controller: 'UnauthorizedUserZoomController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('unauthorizedUserZoom');
                        return $translate.refresh();
                    }]
                }
            });
    });
